// gatsby-browser.js
// ES6
export const onInitialClientRender = () => {}

export const shouldUpdateScroll = ({ routerProps }) => {
  const disableScrollUpdate = routerProps.location.state?.disableScrollUpdate

  return !disableScrollUpdate
}
